import { Badge, Fab, Tooltip } from '@mui/material';
import { useMemo } from 'react';
import Permissions from 'src/Common/Permissions';
import useEkko from 'src/Common/Providers/EkkoProvider';

interface Props {
  onClick: () => void;
  content: React.JSX.Element;
  tooltip: string;
  flipText?: string;
  requiredPermission?: Permissions;
  disabled?: boolean;
}

export const ContentControlButton = ({
  onClick,
  content,
  tooltip,
  flipText,
  requiredPermission,
  disabled,
}: Props): React.JSX.Element => {
  const { hasPermission } = useEkko();
  const isPermitted = useMemo(
    () => (requiredPermission !== undefined ? hasPermission(requiredPermission) : true),
    [hasPermission, requiredPermission],
  );
  const isDisabled = useMemo(() => disabled === true, [disabled]);

  const button = useMemo(
    () => (
      <Fab color={'primary'} onClick={onClick}>
        {content}
        {flipText && (
          <Badge badgeContent={flipText} overlap={'circular'} color={'secondary'} sx={{ bottom: -26, left: -26 }} />
        )}
      </Fab>
    ),
    [onClick, flipText, hasPermission],
  );

  if (!isPermitted || isDisabled) {
    return <></>;
  }

  return (
    <Tooltip title={tooltip} aria-label={tooltip} placement={'bottom'} enterDelay={500} leaveDelay={200}>
      {button}
    </Tooltip>
  );
};
